import { Component, OnInit, AfterViewInit,Input, SimpleChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../../core/auth/auth.service';
import { UserService } from '../../../../core/user.service';
import * as Chart from "chart.js";
import { bloomAdd } from '@angular/core/src/render3/di';
import {MatDialog, MatDialogConfig} from "@angular/material";
import { LoganalyticsDeviceComponent } from '../../../../_models/loganalytics-device/loganalytics-device.component';

@Component({
  selector: 'app-cqmns-log-devicesummary',
  templateUrl: './cqmns-log-devicesummary.component.html',
  styleUrls: ['./cqmns-log-devicesummary.component.css']
})
export class CqmnsLogDevicesummaryComponent implements OnInit {

  @Input() logUpload: any;
  val:any;
  showValue:any;
  selectedSource = '';
  oldField="";
  order=true;
  isDesc = false;
  sortNameIcon = 'fa fa-sort';
  sortManagerIcon = 'fa fa-sort';
  sortCreatedIcon = 'fa fa-sort';
  sortStatusIcon = 'fa fa-sort';
  oldField1="";
  order1=true;
  isDesc1 = false;
  sortNameIcon1 = 'fa fa-sort';
  sortManagerIcon1 = 'fa fa-sort';
  sortCreatedIcon1 = 'fa fa-sort';
  sortStatusIcon1 = 'fa fa-sort';
  oldField2="";
  order2=true;
  isDesc2 = false;
  sortNameIcon2 = 'fa fa-sort';
  sortManagerIcon2 = 'fa fa-sort';
  sortCreatedIcon2 = 'fa fa-sort';
  sortStatusIcon2 = 'fa fa-sort';
  projects: any;
  projectId: any;
  gadatausers: any;
  hostUrl;
  userdate: any;
  userscount: any;
  ctxgaLogOs:any;
  canvasgaLogOs: any;
  myChartgalogOs: any;
  myChartgauserScreen: any;
  myChartgalogBrowsers: any;
  gausersOs: any = [];
  gausersBrowsers: any;
  date:any;
  classificationsgausers = [];
  noOfclassificationsgausers = [];
  myChartgalogOss:any;
  myChartgalogOsgaUser: any;
  ctxgalogBrowsers: any;
  canvasgalogBrowsers: any;
  ctxgauserScreen: any;
  canvasgauserScreen: any;
  labels: any = [];
  data : any = [];
  isShow = false;
  colors = [
    "rgb(224,102,102)",
    "rgb(147,196,125)",
    "rgb(246,178,107)",
    "rgb(219, 121, 162)",
    "rgb(111,168,220)",
    "rgb(142,124,195)",
    
    "rgb( 127,96,0)",
    "rgb( 19,79,92)",
    "rgb(153,153,153)",
    "rgb(102, 224, 224)",

    "rgb(224,102,221)",
    "rgb(246,178,117)",
    "rgb(147,196,200)",
    "rgb(189,165,121)",
    "rgb(111,168,110)",
    "rgb(142,124,171)",
    "rgb(194,123,167)",
    "rgb( 127,96,6)",
    "rgb( 19,79,192)",
    "rgb(153,153,103)",
    "rgb(102, 224, 114)",

    "rgb(224,233,102)",
    "rgb(246,112,107)",
    "rgb(147,123,125)",
    "rgb(189,234,175)",
    "rgb(111,112,220)",
    "rgb(142,98,195)",
    "rgb(194,34,160)",
    "rgb( 127,134,0)",
    "rgb( 19,143,92)",
    "rgb(153,112,153)",
    "rgb(102, 117, 224)"
   
    ];
    gausersScreen: any;
    deviceCategory :any;
    totalOs: any = [];
    totalScreen: any = [];
    totalBrowsers: any = [];
    showOs=false;
    showBrowser=false;
    showScreen=false;
    datagauserOs: any =[];
    datagauserScreen: any =[];
    datagauserBrowser: any =[];
    valueOs: any;
    durationOs: any;
    durationBrowser: any;
    valueBrowser: any;
    durationScreen: any;
    valueScreen: any;
    viewIdApiDevice: any;
    visitedPages: any;
    userId: any;
  constructor(private http: HttpClient, 
    private route: ActivatedRoute,
     private userService: UserService,private dialog: MatDialog,private authService: AuthService, 
     ) { }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl=this.userService.getUrl();
    this.userId = localStorage.getItem("userid");
    this.projectId = localStorage.getItem("projectId");
    this.deviceCategory = 'title1'
    this.showOs = true;
    // this.getDevice();
    this.getDevice()
    this.ngAfterViewInit ();
  }
    ngOnChanges(changes:SimpleChanges){
    console.log('in ngOnChange',this.logUpload)
    this.showValue = changes.logUpload.currentValue;
    console.log('in changes',changes)
    console.log('in show value',this.showValue)
    if (this.datagauserOs) {
      this.datagauserOs = [];
    }
    if (this.datagauserBrowser) {
      this.datagauserBrowser = [];
    }
    if(this.showValue === "false"){
      this.getDevice()
      this.ngAfterViewInit ();
    }
     
  } 
onchange(val) {
  this.val = val;
}
    getDevice(){
      
    this.http.get(encodeURI(this.hostUrl+'/api/issue/osCountFromLog/' + this.projectId))
    .subscribe(data => {
      this.gausersOs = data;
      // this.totalOs = this.gausersOs[0].totaluser;
     for (let i = 0; i < this.gausersOs.length-1; i++) {
      this.datagauserOs.push(this.gausersOs[i]);
    }
    console.log(this.datagauserOs)
     if (this.myChartgalogOs !== undefined) {
      if (this.myChartgalogOs) {
        this.myChartgalogOs.destroy();
      }
      this.createOschart();
      this.updateChartgaUserOs(this.myChartgalogOs); 
    }
    });
  
    this.http.get(encodeURI(this.hostUrl+'/api/issue/browserDataFromLog/' + this.projectId))
    .subscribe(data => {
      this.gausersBrowsers = data;
      for (let i = 0; i < this.gausersBrowsers.length-1; i++) {
        this.datagauserBrowser.push(this.gausersBrowsers[i]);
      }
      this.totalBrowsers  = this.gausersBrowsers[0].totaluser;

     console.log( this.gausersBrowsers)
     if (this.myChartgalogBrowsers !== undefined) {
      if (this.myChartgalogBrowsers) {
        this.myChartgalogBrowsers.destroy();
      }
      this.createBrowserchart();
      this.updateChartgaUserBrowsers(this.myChartgalogBrowsers); 
    }
    });
    
    }
  
  ngAfterViewInit() {
      this.createOschart();
      this.createBrowserchart();
  }
  openDialogPie(val) {
    this.deviceCategory = val;
    console.log(this.deviceCategory)
    if(this.deviceCategory === "title1"){
    const dialogRef = this.dialog.open(LoganalyticsDeviceComponent, {
            data: {
              'devicetype': this.deviceCategory,
              'tabledata': this.datagauserOs,
            },
              width: '50%',
            
          });
          dialogRef.afterClosed().subscribe(result => {
          });
    }else if(this.deviceCategory ==="title2"){
      const dialogRef = this.dialog.open(LoganalyticsDeviceComponent, {
              data: {
                'devicetype': this.deviceCategory,
                'tabledata': this.datagauserBrowser,
              },
              width: '50%',
              
          });
          dialogRef.afterClosed().subscribe(result => {
          });
      }
  }
  openDialog(val) {
    this.deviceCategory = val;
    console.log(this.deviceCategory)
    if(this.deviceCategory === 'title1'){
    this.showOs = true;
    this.showBrowser=false;
    this.showScreen=false;
    }else if(this.deviceCategory ==='title2'){
      this.showBrowser=true;
      this.showOs = false;
    this.showScreen=false;
      }else if(this.deviceCategory ==='title3'){
        this.showScreen = true;
        this.showBrowser=false;
        this.showOs = false;
        }
}
    
  toggleDisplay() {
    this.isShow = !this.isShow;
  }




  createOschart(){
    this.selectedSource = 'O'
    Chart.defaults.global.defaultFontColor = "#000";
    this.canvasgaLogOs = document.getElementById("myChartgalogOs");
    if (this.canvasgaLogOs !== null) {
    this.ctxgaLogOs = this.canvasgaLogOs.getContext("2d");
    this.myChartgalogOs = new Chart(this.ctxgaLogOs, {
      type: "pie",
      data: {
        labels: [],
        datasets: [
          {
            label: "# of Votes",
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Operating System',
          fontColor: "#5f7388",
          fontSize: 15
      },
        responsive: true,
        display: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom'
       },
      }
    });
  }
}
createBrowserchart(){
  this.selectedSource = 'O'
  Chart.defaults.global.defaultFontColor = "#000";
   this.canvasgalogBrowsers = document.getElementById("myChartgalogBrowsers");
    if (this.canvasgalogBrowsers !== null) {
    this.ctxgalogBrowsers = this.canvasgalogBrowsers.getContext("2d");
    this.myChartgalogBrowsers = new Chart(this.ctxgalogBrowsers, {
      type: "pie",
      data: {
        labels: [],
        
        datasets: [
          {
            label: "# of Votes",
            data: [],
            backgroundColor: [],
            borderWidth: 1
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: 'Browser',
          fontColor: "#5f7388",
          fontSize: 15
      },
        responsive: true,
        display: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom'
       },
      }
    });
  }
}

  
  updateChartgaUserOs(myChartgalogOs) {
    for (let i = 0; i < this.datagauserOs.length; i++) {
      myChartgalogOs.data.labels.push(this.datagauserOs[i].os);
      myChartgalogOs.data.datasets[0].data.push(this.datagauserOs[i].user_percent);
      myChartgalogOs.data.datasets[0].backgroundColor.push(this.getColor(i));

    }
    myChartgalogOs.update();
  }
  updateChartgaUserBrowsers(myChartgalogBrowsers) {
    for (let i = 0; i < this.datagauserBrowser.length; i++) {
      myChartgalogBrowsers.data.labels.push(this.datagauserBrowser[i].browser);
      myChartgalogBrowsers.data.datasets[0].data.push(this.datagauserBrowser[i].user_percent);
      myChartgalogBrowsers.data.datasets[0].backgroundColor.push(this.getColor(i));

    }
    myChartgalogBrowsers.update();
  }
  getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 50; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  getColor(num) {
    if (num < 50) {
      return this.colors[num];
    } else {
      this.getRandomColor();
    }
  }
  sortBy(field){
    if(this.oldField==field){
        this.isDesc = !this.isDesc;
        this.order=!this.order;
    } else {
        this.isDesc = false;
        this.order=false;
        this.oldField=field;
    }
    if(this.order){
        field="-"+field;
    }
    if (field === 'user_category' || field === '-user_category') {
        this.sortNameIcon = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
        this.sortManagerIcon = "fa fa-sort";
         this.sortCreatedIcon = "fa fa-sort";
         this.sortStatusIcon = "fa fa-sort";
    } else if (field === 'os' || field === '-os') {
        this.sortManagerIcon = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
        this.sortNameIcon = "fa fa-sort";
        this.sortCreatedIcon = "fa fa-sort";
         this.sortStatusIcon = "fa fa-sort";
    } else if (field === 'users' || field === '-users') {
        this.sortCreatedIcon = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
        this.sortNameIcon = "fa fa-sort";
        this.sortManagerIcon = "fa fa-sort";
         this.sortStatusIcon = "fa fa-sort";
    } else if (field === 'user_percent' || field === '-user_percent') {
        this.sortStatusIcon = this.isDesc ? "fa fa-sort-desc" : "fa fa-sort-asc";
        this.sortNameIcon = "fa fa-sort";
        this.sortManagerIcon = "fa fa-sort";
        this.sortCreatedIcon = "fa fa-sort";
     }
    this.datagauserOs=this.datagauserOs.sort(this.userService.dynamicSort(field))
    }
    sortByBrowser(field){
      if(this.oldField1==field){
          this.isDesc1 = !this.isDesc1;
          this.order1=!this.order1;
      } else {
          this.isDesc1 = false;
          this.order1=false;
          this.oldField1=field;
      }
      if(this.order1){
          field="-"+field;
      }
      if (field === 'device_category' || field === '-device_category') {
          this.sortNameIcon = this.isDesc1 ? "fa fa-sort-desc" : "fa fa-sort-asc";
          this.sortManagerIcon = "fa fa-sort";
           this.sortCreatedIcon = "fa fa-sort";
           this.sortStatusIcon = "fa fa-sort";
      } else if (field === 'browser' || field === '-browser') {
          this.sortManagerIcon = this.isDesc1 ? "fa fa-sort-desc" : "fa fa-sort-asc";
          this.sortNameIcon = "fa fa-sort";
          this.sortCreatedIcon = "fa fa-sort";
           this.sortStatusIcon = "fa fa-sort";
      } else if (field === 'user' || field === '-user') {
          this.sortCreatedIcon = this.isDesc1 ? "fa fa-sort-desc" : "fa fa-sort-asc";
          this.sortNameIcon = "fa fa-sort";
          this.sortManagerIcon = "fa fa-sort";
           this.sortStatusIcon = "fa fa-sort";
      } else if (field === 'user_percent' || field === '-user_percent') {
          this.sortStatusIcon = this.isDesc1? "fa fa-sort-desc" : "fa fa-sort-asc";
          this.sortNameIcon = "fa fa-sort";
          this.sortManagerIcon = "fa fa-sort";
          this.sortCreatedIcon = "fa fa-sort";
       }
      this.datagauserBrowser=this.datagauserBrowser.sort(this.userService.dynamicSort(field))
      }
    
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqmns-log-analytics/cqmns-log-devicesummary/cqmns-log-devicesummary.component.ts